const animateImages = () => {
  document.querySelectorAll(".section-main-blog").forEach((section) => {
    const targets = section.querySelectorAll(".observe-me");
    if (!targets.length) return;
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-inview");
        instance.unobserve(entry.target);
        setTimeout(() => entry.target.classList.remove("is-inview", "observe-me"), 1000);
      });
    }, { root: null, rootMargin: "0px", threshold: 0 });
    targets.forEach((target) => observer.observe(target));
  });
};

const hydratePaginationInputs = () => {
  const totalPagesInput = document.querySelector("[data-total-pages]");
  const currentPageInput = document.querySelector("[data-current-page]");
  const nextUrlInput = document.querySelector("[data-next-url]");
  if (!totalPagesInput || !currentPageInput || !nextUrlInput) return false;

  let currentPage = Number.parseInt(currentPageInput.value, 10);
  if (!Number.isFinite(currentPage) || currentPage < 1) {
    currentPage = Number.parseInt(
      document.querySelector(".pagination__item--current")?.textContent,
      10,
    );
    if (Number.isFinite(currentPage) && currentPage > 0) {
      currentPageInput.value = String(currentPage);
      currentPageInput.dataset.currentPage = String(currentPage);
    }
  }

  let totalPages = Number.parseInt(totalPagesInput.value, 10);
  if (!Number.isFinite(totalPages) || totalPages < 1) {
    const pageNumbers = Array.from(
      document.querySelectorAll(".pagination__list a[href*='page=']"),
      (link) => Number.parseInt(link.getAttribute("href")?.match(/[?&]page=(\d+)/)?.[1], 10),
    ).filter(Number.isFinite);
    if (Number.isFinite(currentPage)) pageNumbers.push(currentPage);
    totalPages = Math.max(...pageNumbers);
    if (Number.isFinite(totalPages) && totalPages > 0) {
      totalPagesInput.value = String(totalPages);
      totalPagesInput.dataset.totalPages = String(totalPages);
    }
  }

  if (!nextUrlInput.value) {
    const nextUrl = document.querySelector(".pagination__item--next")?.getAttribute("href");
    if (nextUrl) {
      nextUrlInput.value = nextUrl;
      nextUrlInput.dataset.nextUrl = nextUrl;
    }
  }

  return Number.isFinite(currentPage)
    && Number.isFinite(totalPages)
    && currentPage < totalPages
    && Boolean(nextUrlInput.value);
};

const loadItems = async (button) => {
  if (!hydratePaginationInputs()) return;
  const totalPagesInput = document.querySelector("[data-total-pages]");
  const currentPageInput = document.querySelector("[data-current-page]");
  const nextUrlInput = document.querySelector("[data-next-url]");
  if (!totalPagesInput || !currentPageInput || !nextUrlInput || button.disabled) return;

  const totalPages = Number.parseInt(totalPagesInput.value, 10);
  const currentPage = Number.parseInt(currentPageInput.value, 10) + 1;
  const nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, `page=${currentPage}`);
  currentPageInput.value = String(currentPage);
  button.disabled = true;
  button.classList.add("loading");

  try {
    const response = await fetch(nextUrl, { headers: { Accept: "text/html" } });
    if (!response.ok) throw new Error(`Load more request failed with status ${response.status}`);
    const responseDocument = new DOMParser().parseFromString(await response.text(), "text/html");
    const incomingGrid = responseDocument.querySelector(".load-more-grid");
    const targetGrid = document.querySelector(".load-more-grid");
    if (incomingGrid && targetGrid) targetGrid.insertAdjacentHTML("beforeend", incomingGrid.innerHTML);
    if (typeof colorSwatches === "function") colorSwatches();
  } catch (error) {
    console.error(error);
  } finally {
    if (currentPage <= totalPages) {
      const scrollData = document.querySelector(".infinite-scroll__data");
      if (scrollData && currentPage !== totalPages) {
        const nextInput = scrollData.querySelector("input[data-next-url]");
        const pageInput = scrollData.querySelector("input[data-current-page]");
        if (nextInput) {
          nextInput.dataset.nextUrl = nextUrl;
          nextInput.value = nextUrl;
        }
        if (pageInput) {
          pageInput.dataset.currentPage = String(currentPage);
          pageInput.value = String(currentPage);
        }
        checkVisibility();
      }
      button.disabled = false;
      button.classList.remove("loading");
      if (currentPage === totalPages) button.remove();
      animateImages();
      if (typeof loadeMoreSlider_G === "function") loadeMoreSlider_G();
    }
  }
};

const checkVisibility = () => {
  document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
    if (spinner.dataset.infiniteObserverBound === "true") return;
    spinner.dataset.infiniteObserverBound = "true";
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        delete spinner.dataset.infiniteObserverBound;
        loadItems(spinner);
      });
    });
    observer.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => loadItems(button);
  });
  if (hydratePaginationInputs()) checkVisibility();
  animateImages();
}

loadMore();
